import Color from '@/Enums/Color.enum';
import classNames from 'classnames';

interface IProps {
  label: string;
  total: number;
  shown: number;
  productName: string;
  className?: string;
}

const ProductInventoryFooter = ({ label, total, shown, productName, className }: IProps) => (
  <div className={classNames('px-4 py-2 border-t text-[13px] truncate', `text-[${Color.Grey}]`, className)}>
    {shown === total ? `${total}` : `Showing ${shown} of ${total}`} {label} in{' '}
    <span className='font-semibold text-[#303030]'>{productName}</span>
  </div>
);

export default ProductInventoryFooter;
